export default {
    //Splash
    splash_message: 'Nền tảng giao tiếp và đào tạo',

    //TTCC
    accept_ttcc: 'Chấp nhận Điều khoản & Điều kiện',

    //Login
    welcome: 'Chào mừng!',
    welcome_message: 'dots, đồng minh công nghệ mới của bạn trong giao tiếp và đào tạo.',
    username: 'Tên người dùng',
    password: 'Mật khẩu',
    code: 'Mã',
    recover_password: 'Khôi phục mật khẩu',
    log_in: 'Đăng nhập',
    log_in_biometrics: 'Đăng nhập bằng dữ liệu sinh trắc học',
    create_user: 'Tạo người dùng',
    recover_access_to_account: 'Nhập tên người dùng của bạn để khôi phục quyền truy cập vào tài khoản của bạn',
    back: 'Quay lại',
    enter_new_password: 'Nhập mã và mật khẩu mới của bạn',
    enter_code: 'Nhập mã',
    new_password: 'Mật khẩu mới',
    repeat_new_password: 'Nhập lại mật khẩu mới',
    validate: 'Xác nhận',
    complete_all_fields: 'Điền đầy đủ tất cả các trường',
    passwords_do_not_match: 'Mật khẩu không khớp',
    user_created_successfully: 'Tạo người dùng thành công',
    create_user: 'Tạo người dùng',
    required_fields: 'Trường bắt buộc',
    confirm_your_email: 'Xác nhận email của bạn',
    confirm_your_phone: 'Xác nhận số điện thoại của bạn',
    confirm_password: 'Xác nhận mật khẩu của bạn',
    modifying_email: 'Bạn đang thay đổi email của mình',
    validate_code: 'Xác nhận mã',
    code_sent_successfully: 'Mã đã được gửi thành công',
    password_reset: 'Mật khẩu của bạn đã được đặt lại thành công',
    enter_confirmation_code: 'Nhập mã xác nhận của bạn',
    enter_your_new_email: 'Nhập email mới của bạn',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Ôi! Chúng tôi không thể tìm thấy tài khoản của bạn',
    contact_the_administrator:
        'Có vẻ như người dùng bạn nhập không tồn tại.\nHãy kiểm tra lại xem nó có được viết chính xác không\nhoặc liên hệ với quản trị viên.',
    invalid_user_or_pass: 'Tên người dùng và/hoặc mật khẩu không hợp lệ',
    info_is_not_correct: 'Một số thông tin không chính xác, vui lòng thử lại.',
    enter_user: 'Vui lòng nhập tên người dùng',
    nonexistent_user: 'Người dùng không tồn tại. Vui lòng thử lại.',
    incorrect_code: 'Mã không chính xác',
    change_saved_successfully: 'Thay đổi đã được lưu thành công',
    pass_changed_successfully: 'Mật khẩu đã được thay đổi thành công',
    check_your_email: 'Kiểm tra email của bạn để nhận mã xác minh',
    eight_characters: '*Phải có ít nhất 8 ký tự',
    one_uppercase_letter: '*Phải có ít nhất 1 chữ cái viết hoa',
    one_special_character: '*Phải có ít nhất 1 ký tự đặc biệt (@, $, !, #, ?)',
    pass_requirements:
        'Bạn phải đáp ứng các yêu cầu sau:\n\n*Phải có ít nhất 8 ký tự\n*Phải có ít nhất 1 chữ cái viết hoa\n*Phải có ít nhất 1 ký tự đặc biệt (ví dụ: @, $, !, #, ?)',
    select_date: 'Chọn một ngày',
    cannot_create_password: 'Không thể tạo mật khẩu',
    complete_your_details: 'Hoàn thành thông tin của bạn để tiếp tục',
    validate_code: 'Xác minh mã',
    enter_valid_number: 'Bạn phải nhập một số hợp lệ',
    complete_numbers:
        'Tiền tố "15" phải được loại bỏ để số cuối cùng có tổng cộng 13 chữ số. Ví dụ: +54 9 XXX XXX XXXX, bạn cần nhập đầy đủ 10 số còn lại.',

    //Profile
    insufficient_permissions: 'Quyền không đủ',
    permissions_are_required: 'Cần có quyền để truy cập camera và thư viện ảnh.',
    choose_font: 'Chọn phông chữ',
    where_do_you_want: 'Bạn muốn chọn hình ảnh từ đâu?',
    camera: 'Máy ảnh',
    gallery: 'Thư viện',
    edit_photo: 'Chỉnh sửa ảnh',
    cancel: 'Hủy',
    save: 'Lưu',
    app: 'Ứng dụng',
    support: 'Hỗ trợ',
    other: 'Khác',
    contact_channel: 'Kênh liên hệ',
    select_the_contact_channel: 'Chọn kênh liên hệ',
    subject: 'Chủ đề',
    write_the_subject: 'Viết chủ đề',
    message: 'Tin nhắn',
    write_a_comment: 'Viết bình luận',
    send: 'Gửi',
    sent_successfully: 'Đã gửi thành công',
    thank_you_for_leaving_us_your_comments: 'Cảm ơn bạn đã để lại bình luận, chúng tôi sẽ sớm liên hệ với bạn.',
    close: 'Đóng',
    check_for_update: 'Kiểm tra cập nhật',
    clear_cache: 'Xóa bộ nhớ đệm',
    delete_account: 'Xóa tài khoản',
    log_out: 'Đăng xuất',
    notifications: 'Thông báo',
    permissions_to_access: 'Cần có quyền để truy cập vào camera và thư viện ảnh.',
    select_the_image: 'Bạn muốn chọn hình ảnh từ đâu?',
    change_language: 'Thay đổi ngôn ngữ',
    change_language_title: 'Quan trọng!',
    change_language_message:
        'Để thực hiện hành động này, cần có kết nối internet. Việc này sẽ xóa nội dung đã tải xuống để sử dụng ngoại tuyến. Lưu ý rằng thay đổi này chỉ ảnh hưởng đến nội dung trong ứng dụng và không ảnh hưởng đến cấu trúc của ứng dụng, điều này phụ thuộc vào ngôn ngữ của thiết bị của bạn.',
    logout_not_available: 'Không thể đăng xuất',
    cant_logout: 'Bạn không thể đăng xuất ngay bây giờ vì không có kết nối internet. Vui lòng kiểm tra kết nối của bạn và thử lại.',
    //nuevos al 01-08-2024
    cache_cleared: 'Đã xóa bộ nhớ đệm thành công',
    deletes_the_content:
        'Hành động này sẽ xóa nội dung đã tải xuống để sử dụng ứng dụng ở chế độ ngoại tuyến. Đảm bảo rằng bạn có kết nối internet để tiếp tục duyệt.',
    error_uploading_image: 'Lỗi khi tải hình ảnh lên: ',
    there_was_an_error: 'Đã xảy ra lỗi khi tải hình ảnh lên. Vui lòng thử lại.',
    //nuevos al 21-11-2024
    email: 'Email',
    phone: 'Điện thoại',
    name: 'Tên',
    last_name: 'Họ',
    role: 'Vai trò',
    verify: 'Xác minh',
    verified: 'Đã xác minh',
    contact_channels: 'Kênh liên lạc',
    editing_your_email: 'Bạn đang chỉnh sửa email của mình',
    editing_your_phone: 'Bạn đang chỉnh sửa số điện thoại của mình',
    modifying_your_email:
        'Bạn đang thay đổi email của mình, bạn sẽ nhận được mã để nhập vào email của bạn. Nếu bạn chưa nhận được mã, vui lòng kiểm tra lại.',
    modifying_your_phone:
        'Bạn đang thay đổi số điện thoại di động của mình, bạn sẽ nhận được mã SMS để nhập vào. Nếu bạn chưa nhận được mã, vui lòng kiểm tra lại.',

    //Notifications
    all: 'Tất cả',
    unread: 'Chưa đọc',
    read: 'Đã đọc',
    seen: 'Đã xem',
    notifications: 'Thông báo',
    here_you_will_find: 'Tại đây bạn sẽ tìm thấy tất cả các thông báo và cảnh báo!',
    mark_all_read: 'Đánh dấu tất cả là đã đọc',
    you_have_no_notifications: 'Bạn không có thông báo nào!',
    you_will_soon_start: 'Bạn sẽ sớm nhận được những thông tin mới.',

    //Buscador
    enter_your_search: 'Nhập tìm kiếm của bạn',
    no_results: 'Không có kết quả',
    search_content: 'Tìm kiếm nội dung bạn quan tâm.',
    see: 'Xem',
    results_in: 'kết quả trong',
    see_less_results: 'Xem ít kết quả hơn',
    all: 'Tất cả',
    wall: 'Tường',
    learning: 'Đào tạo',
    benefits: 'Lợi ích',
    portfolio: 'Danh mục đầu tư',
    retry: 'Thử lại',
    locked: 'Bị khóa',
    pending: 'Đang chờ',
    seen: 'Đã xem',
    approved: 'Đã phê duyệt',

    //Posts
    see_them: 'Xem ',
    _comments: ' bình luận',
    reactions_from_other_users: 'Phản hồi từ những người dùng khác',
    not_connected_to_the_network: 'Bạn không kết nối với mạng',
    comment: 'Bình luận',
    comments: 'Bình luận',
    write_a_comment: 'Viết một bình luận',
    no_content: 'Không có nội dung',
    reaction: 'Phản ứng',
    reactions: 'Phản ứng',
    first_comment: 'Hãy là người đầu tiên để lại bình luận!',
    no_comment: 'Chưa có bình luận nào trong bài đăng này.',
    write_a_comment: 'Viết một bình luận',
    no_publications: 'Không có bài đăng',
    no_post_to_read: 'Bạn không có bài đăng nào để đọc.',
    views: 'lượt xem',
    reply: 'Trả lời',
    see: 'Xem ',
    more_answers: 'trả lời thêm',
    hide: 'Ẩn ',
    answers: ' câu trả lời',
    no_reactions: 'Chưa có phản ứng nào!',
    leave_your_reaction: 'Hãy là người đầu tiên để lại phản ứng của bạn.',
    //nuevos al 01-08-2024
    full_survey: 'Bạn đã hoàn thành khảo sát!',
    thanks_for_participating: 'Cảm ơn bạn đã tham gia, bạn đã giúp chúng tôi cải thiện mỗi ngày.',
    sent_automatically: 'Sẽ tự động gửi khi bạn có kết nối lại.',
    no_post_saved: 'Chưa có bài đăng nào được lưu',
    see_your_favorite_content: 'Đây là nơi bạn sẽ thấy nội dung yêu thích của mình.',

    //Fechas
    instant: 'Vừa mới đây',
    hourFirst: 'Cách đây ',
    hour: ' giờ',
    hours: ' giờ',
    day: ' ngày',
    days: ' ngày',

    //Learning
    congratulations: 'Chúc mừng!',
    you_approved: 'Bạn đã hoàn thành với ',
    you_completed: 'Bạn đã hoàn thành khóa học này',
    you_disapproved: 'Bài kiểm tra không đạt',
    score: 'Điểm số:',
    return_to_course: 'Quay lại khóa học',
    retry: 'Thử lại',
    it_is_available: 'Đã sẵn sàng',
    total_course_evaluation: 'Đánh giá tổng thể khóa học',
    evaluate_me: 'ĐÁNH GIÁ TÔI',
    completed_the_course: 'Bạn đã hoàn thành khóa học',
    pending_approval: 'Đang chờ phê duyệt',
    return: 'Quay lại',
    continue_course: 'Tiếp tục khóa học',
    you_have_made: 'Bạn đã thực hiện ',
    of_the_course: ' của khóa học',
    locked: 'đã khóa',
    pending: 'đang chờ',
    seen: 'đã xem',
    complete: 'hoàn thành',
    reprobate: 'không đạt',
    sync_pend: 'đang đồng bộ',
    in_progress: 'đang tiến hành',
    perform_evaluation: 'Thực hiện đánh giá',
    next_content: 'Nội dung tiếp theo',
    you_completed_all: 'Bạn đã hoàn thành tất cả các nội dung',
    final_evaluation: 'ĐÁNH GIÁ CUỐI KỲ',
    retry_mayus: 'THỬ LẠI',
    see_more: '...xem thêm',
    see_less: '...xem ít hơn',
    back_to_course: 'QUAY LẠI KHÓA HỌC',
    click_to_see: 'Nhấn để xem',

    //Evaluaciones
    evaluation: 'Đánh giá: ',
    of: ' trong ',
    loading_evaluation: 'Đang tải đánh giá...',
    select_option: 'Bạn phải chọn một tùy chọn để tiếp tục',
    select_one_answer: 'Vui lòng chọn ít nhất một câu trả lời cho mỗi câu hỏi.',
    exit_evaluation: 'Bạn có muốn rời khỏi đánh giá không?',
    your_answers_will_not_be_saved: 'Nếu bạn rời đi ngay bây giờ, các câu trả lời của bạn sẽ không được lưu và bạn sẽ không nhận được điểm số',
    continue_evaluation: 'Tiếp tục đánh giá',
    leave_anyway: 'Rời đi dù sao',
    try_again: 'Hãy thử lại!',
    passed_the_evaluation: 'Bạn đã vượt qua đánh giá',
    start_the_course_again: 'Bạn không đạt đủ điểm để vượt qua đánh giá. Hãy bắt đầu lại khóa học để hoàn thành.',
    evaluation_pending_approval: 'Đánh giá đang chờ phê duyệt',
    notification_result_evaluation: 'Bạn sẽ sớm nhận được thông báo về kết quả đánh giá của mình',
    write_here: 'Viết vào đây...',
    close: 'Đóng',
    confirm: 'Xác nhận',
    sync_pending: 'Đang chờ đồng bộ',
    view_certificate: 'Xem chứng chỉ',
    // nuevos al 27-01-2025
    course_download_in_process: 'Đang tải khóa học',
    course_is_downloading:
        'Vui lòng đợi vài giây. Khóa học đang được tải xuống để bạn có thể truy cập toàn bộ nội dung ngoại tuyến mà không gặp vấn đề gì.',
    downloaded_course: 'Khóa học đã tải xuống thành công',
    you_can_train_offline: 'Xong rồi! Bây giờ bạn có thể luyện tập ngoại tuyến.',
    delete_offline_course: 'Bạn có muốn xóa bản tải xuống khóa học này khỏi chế độ ngoại tuyến?',
    not_view_course_offline: 'Bạn sẽ không thể xem khóa học này trong chế độ ngoại tuyến.',
    course_is_not_available: 'Khóa học không còn khả dụng...',
    not_available_offline: 'Khóa học này không còn khả dụng ngoại tuyến, nhưng bạn có thể tải lại khi cần.',
    content_download_in_process: 'Đang tải nội dung',
    content_is_downloading: 'Vui lòng đợi vài giây. Nội dung đang được tải xuống để bạn có thể truy cập tất cả ngoại tuyến mà không gặp vấn đề gì.',
    downloaded_content: 'Nội dung đã tải xuống thành công',
    delete_offline_content: 'Bạn có muốn xóa nội dung ngoại tuyến không?',
    not_view_content_offline: 'Khi xóa, bạn sẽ không thể truy cập nội dung ngoại tuyến.',
    content_is_not_available: 'Nội dung không còn khả dụng...',
    download_offline: 'Tải xuống ngoại tuyến',
    available_offline: 'Có sẵn ngoại tuyến',
    delete: 'Xóa bỏ',

    //Stores
    your_progress_in_stores: 'Tiến độ của bạn trong cửa hàng',
    map: 'Bản đồ',
    daily_survey: 'Tiến độ hàng ngày',
    survey: 'Khảo sát',
    matutino: 'BUỔI SÁNG',
    vespertino: 'BUỔI CHIỀU',
    form: 'Biểu mẫu',
    enter_a_number: 'Nhập một số',
    campaign_expiration: 'HẾT HẠN CHIẾN DỊCH: ',
    store_indicators: 'Chỉ số cửa hàng',
    last_days: 'Tương ứng với 30 ngày qua',
    main_indicators: 'Biết được tiến độ của các chỉ số chính trong cửa hàng',
    store_information: 'Tìm thông tin quan trọng về cửa hàng để đạt các cấp độ Tiệm Hoàn Hảo tối ưu',
    perform_executions: 'Thực hiện các bước sau để biết trạng thái của cửa hàng',
    pending_mayus: 'ĐANG CHỜ',
    approved_mayus: 'ĐƯỢC CHẤP THUẬN',
    in_review_mayus: 'ĐANG XEM XÉT',
    redo_mayus: 'LÀM LẠI',
    visited_mayus: 'ĐÃ THỰC HIỆN',
    moderation_mayus: 'KIỂM DUYỆT',
    review_mayus: 'XEM LẠI',
    in_progress_mayus: 'ĐANG TIẾN HÀNH',
    sync_pend_mayus: 'ĐANG ĐỒNG BỘ',
    locked_mayus: 'BỊ KHÓA',
    complete_mayus: 'HOÀN TẤT',
    perfect_store: 'Cửa hàng hoàn hảo',
    execution: 'Thực hiện',
    vouchers: 'Voucher',
    send: 'Gửi',
    requires: 'Yêu cầu ',
    variation: 'Biến đổi',
    validity: 'Hiệu lực: ',
    points: 'điểm',
    voucher_canceled: 'Voucher đã bị hủy',
    you_can_try_again: 'Đừng lo lắng! Bạn có thể thử lại.',
    voucher_successful: 'Voucher thành công',
    successful_promo: 'Khuyến mãi đã được thực hiện thành công!',
    voucher_pending: 'Voucher đang chờ xử lý',
    wait_for_the_validation: 'Chờ đợi quá trình xác nhận voucher của bạn hoàn tất',
    your_code_is_being_scanned: 'Mã của bạn đang được quét ⏳',
    view_qr: 'Xem mã QR',
    return_to_store: 'Quay lại cửa hàng',
    stores_objective: 'Cần hoàn thành mục tiêu của cửa hàng.',
    welcome_stores: 'Lập kế hoạch của bạn!',
    tip_day: 'Để giữ vững tiến độ, đừng quên lập kế hoạch hoàn chỉnh cho mọi ngày làm việc.',
    close_mayus: 'ĐÓNG',
    select_form: 'Chọn một biểu mẫu để bắt đầu',
    select_one_form: 'Để bắt đầu, bạn cần chọn một biểu mẫu.',
    answer_all_questions: 'Bạn phải trả lời tất cả câu hỏi để tiếp tục.',
    schedule_not_found: 'Không tìm thấy lịch trình cho hôm nay.',
    form_not_found: 'Không tìm thấy biểu mẫu trong lịch trình.',
    send: 'Gửi',
    check_in: 'Check-in',
    check_out: 'Check-out',
    check_out_done: 'Check-out đã hoàn thành',
    off_route: 'Bạn đang đi lệch tuyến, nhấn vào đây để quay lại lịch trình hôm nay',
    search_barcode: 'Tìm bằng mã vạch',
    no_agenda_today: 'Không có lịch trình nào cho hôm nay!',
    no_agenda_week: 'Không có lịch trình nào cho tuần này!',
    no_information_today: 'Không có lịch trình cho ngày này. Nếu có thắc mắc, hãy liên hệ với quản lý của bạn.',
    no_information_week: 'Không nhận được thông tin cho tài khoản của bạn. Vui lòng liên hệ với quản lý nếu cần.',

    //Camera & Permissions
    not_have_camera_permissions: 'Bạn không có quyền sử dụng máy ảnh',
    activate_from_settings: 'Hãy kích hoạt từ cài đặt của thiết bị để tiếp tục.',
    modify_permissions: 'Chỉnh sửa quyền',
    complete_fields: 'Hoàn thành các trường sau để tạo cửa hàng',
    create: 'Tạo',
    store_name: 'Tên cửa hàng',
    enter_store_name: 'Nhập tên cửa hàng',
    store_address: 'Địa chỉ',
    enter_store_address: 'Nhập địa chỉ cửa hàng',
    cluster: 'Cụm',
    store_phone: 'Điện thoại',
    enter_store_phone: 'Nhập số điện thoại của cửa hàng',

    //Surveys & Goals
    activate_survey: 'Để kích hoạt khảo sát 1.1 Buổi Chiều, bạn cần hoàn thành các mục tiêu của cửa hàng. Mục tiêu: ',
    inactive_vespertino: 'Buổi Chiều chưa hoạt động',
    active_vespertino: 'Buổi Chiều đã hoạt động',
    completed_your_mandatory_objectives: 'Bạn đã hoàn thành các mục tiêu bắt buộc trong ngày, giờ bạn có thể thực hiện Buổi Chiều.',
    complete_now: 'Hoàn thành ngay',
    perform_later: 'Thực hiện sau',
    back_to_your_agenda: 'Bạn có muốn quay lại lịch trình hôm nay không?',
    return_to_the_current_day: 'Bạn đang xem các hoạt động của ngày trước. Nhấn tiếp tục để quay lại ngày hiện tại: ',
    continue: 'Tiếp tục',
    reached_your_goal: 'Bạn đã đạt được mục tiêu!',
    search_by_barcode: 'Tìm bằng mã vạch',
    scan_the_barcode: 'Quét mã vạch của bất kỳ sản phẩm nào trong danh sách này.',
    return_to_form: 'Quay lại Biểu mẫu',
    product_not_found: 'Không tìm thấy sản phẩm',
    code_does_not_match: 'Mã không khớp với bất kỳ sản phẩm nào thuộc biểu mẫu này.',
    search_another_product: 'Tìm sản phẩm khác',
    form_submitted_successfully: ' đã được gửi thành công!',
    send_new_survey: 'Khảo sát đã được gửi thành công.',
    no_agenda_for_today: 'Không có lịch trình nào cho hôm nay!',
    consult_your_supervisor: 'Không có lịch trình cho ngày này. Nếu có thắc mắc, hãy liên hệ với quản lý của bạn.',
    visiting_your_store: 'Bạn đang thăm cửa hàng ',
    you_can_check_out: 'Bạn có thể thực hiện Check-out mà không cần hoàn thành khảo sát: ',
    you_met_the_goal: 'Bạn đã đạt mục tiêu, không cần hoàn thành biểu mẫu.',
    you_must_complete_the_survey: 'Để thực hiện Check-out, bạn phải hoàn thành khảo sát: ',
    checkin_blocked: 'Check-in bị khóa',
    close_the_open_checkin: 'Để tiếp tục, bạn cần đóng Check-in đang mở.',
    close_the_checkin_opened_in: 'Để tiếp tục, bạn cần đóng Check-in đang mở tại: ',
    checkin_out_of_range: 'Check-in ngoài phạm vi',
    more_meters_from_the_store: 'Bạn đang cách cửa hàng hơn 150 mét.',
    now_is_your_turn: 'Giờ là lượt của bạn!',
    surveys_in_progress: 'Bạn có các khảo sát đang tiến hành: ',
    unfinished_surveys: 'Bạn có khảo sát chưa hoàn thành: ',
    want_to_checkout: 'Bạn có chắc muốn thực hiện Check-out không?',
    selected_store: 'Cửa hàng đã chọn',
    checkout_blocked: 'Check-out bị khóa',
    uncompleted_forms: 'Bạn có biểu mẫu chưa hoàn thành!',
    checkout_anyway: 'Bạn có muốn thực hiện Check-out dù sao không?',
    go_to_survey: 'Đi đến khảo sát',
    take_the_survey: 'Bạn có thể thực hiện khảo sát!',
    validity: 'Hiệu lực: ',
    search_store: 'Tìm cửa hàng...',
    no_results_for_your_search: 'Không có kết quả nào cho tìm kiếm của bạn',
    find_another_store: 'Tìm cửa hàng khác',
    //nuevos al 21-11-2024
    loading: 'Đang tải...',
    error_getting_data: 'Lỗi khi lấy dữ liệu.',
    no_information_to_display: 'Không có thông tin để hiển thị.',
    unzipping: 'Giải nén...',
    saving: 'Đang lưu',
    loading_stores: 'Đang tải cửa hàng...',
    getting_stores: 'Đang lấy cửa hàng...',
    request_has_failed: 'Đã đạt số lần thử lại tối đa. Yêu cầu thất bại.',
    a_few_minutes: 'Đang tải cửa hàng...\nQuá trình này có thể mất vài phút.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Tải xuống tài nguyên Perfect Store hoàn tất',
    perfect_store_download: 'Tải ảnh thành công của Perfect Store hoàn tất',
    perfect_store_error: 'Lỗi khi tải tài nguyên Perfect Store',
    connection_interrupted: 'Kết nối bị gián đoạn, ảnh thành công sẽ được giải nén khi kết nối được khôi phục',
    decompressing_perfect_store: 'Đang tải xuống Perfect Store',
    downloading_perfect_store: 'Đang tải xuống Perfect Store',
    saving_perfect_store: 'Đang lưu Perfect Store',
    remain_downloaded: '\nCòn lại để tải ',
    assets: ' tài nguyên.',
    download_complete: 'Tải xuống hoàn tất',

    //Portafolio
    no_brands_to_show: 'Không có thương hiệu nào để hiển thị',
    no_products_to_show: 'Không có sản phẩm nào để hiển thị',
    try_again_later: 'Hãy thử lại sau',
    portfolio: 'Danh mục',
    select_one: 'Chọn một trong các thương hiệu của chúng tôi để xem sản phẩm và dịch vụ.',
    learn_about: 'Khám phá toàn bộ danh mục sản phẩm và dịch vụ trên Ứng dụng của chúng tôi.',
    brand: 'Thương hiệu',
    description: 'Mô tả',
    ingredients: 'Thành phần',
    data_sheet: 'Bảng thông tin',

    //Benefits
    points_can_be_exchanged: 'Có thể được đổi thành: ',
    approved: 'Được chấp nhận',
    cancelled: 'Đã hủy',
    pending: 'Đang chờ xử lý',
    redeemed: 'ĐÃ ĐỔI',
    added_points: 'ĐÃ CỘNG ĐIỂM',
    all: 'Tất cả',
    my_points: 'Điểm của tôi',
    your_points: 'Điểm của bạn',
    delivered: 'Đã giao',
    no_benefits: 'Chưa có lợi ích nào',
    add_points: 'Tích lũy điểm qua các tương tác của bạn để đổi lấy phần thưởng',
    no_history: 'Chưa có lịch sử',
    redeem_your_points: 'Đổi điểm của bạn và xem lịch sử lợi ích tại đây',
    pending_approval: 'Đang chờ phê duyệt',
    when_it_is_approved: 'Khi được phê duyệt, bạn sẽ thấy nó được cập nhật trong lịch sử lợi ích của mình',
    unredeemed_benefit: 'Lợi ích chưa được đổi',
    you_dont_have_enough_points: 'Bạn không đủ điểm để đổi lợi ích này',
    accept: 'Chấp nhận',
    units_available: ' đơn vị có sẵn',
    redeem_benefit: 'Đổi lợi ích',
    benefits_mayus: 'LỢI ÍCH',
    history: 'LỊCH SỬ',
    there_was_a_mistake: 'Đã xảy ra lỗi',

    //Vouchers
    complete_to_redeem_the_voucher: 'Hãy đổi voucher của bạn!',
    valid_until: 'Hiệu lực đến: ',
    quantity_purchased: 'Số lượng kiện hàng: ',
    redeem: 'Đổi',
    lumps: 'Kiện hàng',
    voucher_redeemed: 'Voucher đã được đổi thành công',
    error_redeeming_voucher: 'Đã xảy ra lỗi khi đổi voucher. Hãy thử lại.',
    validate_and_redeem_vouchers: 'Hãy đổi voucher của bạn!',
    to_get_started: 'Quét mã QR để đổi voucher của bạn nhanh chóng và dễ dàng. Đừng bỏ lỡ cơ hội tận dụng lợi ích ngay lập tức!',
    write_your_code: 'Nhập mã của bạn...',
    validate: 'Xác nhận',
    back_to_store: 'Quay lại cửa hàng',
    scan_qr: 'Quét mã QR',
    scan_on_the_voucher: 'Để bắt đầu, hãy quét mã QR trên voucher',
    view_history: 'Xem lịch sử',
    voucher_history: 'Lịch sử voucher',
    voucher_history_description: 'Lịch sử này cho phép bạn quản lý và theo dõi chính xác các lần đổi thưởng của mình.',
    see_more: 'Xem thêm',
    see_less: 'Thu gọn',

    //Faltantes
    upload_image: 'Tải lên hình ảnh',
    uploaded_image: 'Hình ảnh đã được tải lên',
    photo: 'Ảnh',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    enter_a_comment: 'Nhập bình luận',
    enter_a_value: 'Nhập một giá trị',
    want_to_check_out: 'Bạn có chắc chắn muốn thực hiện check-out không?',
    not_check_in_again: 'Khi đã xác nhận, bạn sẽ không thể check-in lại cho đến lần thăm tiếp theo.',

    //Alert
    alert: 'Cảnh báo',
    enter_characters: 'Bạn cần nhập 10 ký tự sau tiền tố',
    numerical_field: 'Trường này phải là số, không được chứa khoảng trắng hoặc chữ cái.',
    enter_date_of_birth: 'Nhập ngày sinh hợp lệ theo định dạng YYYY-MM-DD.',
    session_expired: 'Phiên làm việc đã hết hạn',
    your_session_has_expired: 'Phiên làm việc của bạn đã hết hạn. Vui lòng thử lại.',
    error: 'Lỗi',
    error_occurred: 'Đã xảy ra lỗi khi cố gắng thay đổi mật khẩu.',
    email_verification_code_incorrect: 'Mã xác thực email không chính xác.',
    phone_verification_code_incorrect: 'Mã xác thực số điện thoại không chính xác.',
    no_checkin_found: 'Không tìm thấy đăng ký.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
